import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styles from "./AuthenticatorGoogle.module.css";
import Swal from "sweetalert2";
import axios from "axios";

function AuthenticatorGoogle() {
	const [code, setCode] = useState("");
	const [showCode, setShowCode] = useState(false);
	const navigate = useNavigate();
	const location = useLocation();
	const { qrCodeImageUrl, secret, cuil } = location.state;
	const id = cuil;

	const handleToggleShowCode = (event) => {
		event.preventDefault();
		setShowCode(!showCode);
	};

	const handleChange = (event) => {
		setCode(event.target.value);
	};

	const handleSubmit = async (event) => {
		event.preventDefault();
		try {
			const res = await axios.post(process.env.REACT_APP_AUTHENTICATOR_GOOGLE, { id: id, token:code });

			if (res.data.valid) {
				const token = res.data.token;
				navigate(`/recover/${token}`);
			} else {
				Swal.fire({
					icon: "warning",
					title: "Código incorrecto",
					text: "Por favor, revisa el código e intenta nuevamente",
				});
			}
		} catch (error) {
			Swal.fire({
				icon: "error",
				title: "Oops... Algo salió mal",
				text: "Vuelve a intentarlo",
			});
		}
	};

	return (
		<div className={styles.container}>
			<div className={styles.header}>Google Authenticator</div>
			<form className={styles.form} onSubmit={handleSubmit}>
				<div className={!showCode ? styles.qrCodeContainer : styles.codeContainer}>
					{!showCode && <img src={qrCodeImageUrl} alt="QR Code"/>}
					{showCode && <p>{secret}</p>}
				</div>
				<button className={styles.authButton} onClick={handleToggleShowCode}>
					{showCode ? "Mostrar QR" : "Mostrar Código"}
				</button>
				<br />
				<br />
				<input
					type='text'
					value={code}
					className={styles.inputForm}
					onChange={handleChange}
					placeholder='Ingrese el código de 6 dígitos'
				/>
				<button type='submit' className={styles.authButton}>
					Verificar
				</button>
			</form>
		</div>
	);
}

export default AuthenticatorGoogle;